module.exports = __webpack_public_path__ + "static/img/17.83767c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/17.png
// module id = po9g
// module chunks = 1